import React, { useEffect, useState } from 'react';
import AuthModal from './auth/AuthModal.js';
import axios from "axios";
import { API_ROOT } from '../configs/env-vars.js';
import './custom.scss';

const MainPage = () => {
   const [url, setUrl] = useState('https://jackbit.com');
   const [show,setShow] = useState({login:false,register:false});
   
  const authenticateAction = async(showObject) => {
      await close();
      const middleDiv = document.getElementsByClassName('middle')[0];
      middleDiv.style.height = "96%";
      middleDiv.style.position = "absolute";
      middleDiv.style.zIndex = "100";
      middleDiv.style.right = "-8.7vw";
      middleDiv.style.top = "5vw";
      middleDiv.style.backdropFilter = "blur(8px)";
      setShow({...show, ...showObject})
  }
  
  const close = () => {
      const middleDiv =  document.getElementsByClassName('middle')[0];
      middleDiv.style.background = "";
      middleDiv.style.height = "";
      middleDiv.style.position = "";
      middleDiv.style.zIndex = "";
      middleDiv.style.right = "";
      middleDiv.style.top = "";
      middleDiv.style.backdropFilter = "";
      setShow({...show,login:false,register:false});
  }

  useEffect(() => {
    axios.get(`${API_ROOT}/`)
    .then(res => console.log(res.data))
    .catch(err => console.error(err));
  },[]);

  return (
    <div>
      <div className='header-content'>
        <div>
          <div className="middle">
            <div className="left"></div>   
          </div>
        </div>
      </div> 
      <div>
      <div className='page-wrapper svelte-1v2axqk'>
        <div className='sidebar-wrapper svelte-1aprao7'>
          <aside className='app-sidebar svelte-1aprao7'/>
        </div>
        <main className='svelte-1v2axqk'>
          <header className='app-header svelte-7aozqb'>
            <div className='main-container header svelte-7aozqb'>
              <div className='left svelte-7aozqb'></div>
              <div className='user svelte-7aozqb'>
                <div class="header-unauhtorized svelte-hv3x26">
                    <button class="core-button secondary" onClick={()=>authenticateAction({login:true,register:false})}>
                      <div class="button-content">
                      <span data-group="HEADER" data-key="LOGIN">Log In</span>
                      </div> 
                    </button>
                    <button class="core-button" onClick={()=>authenticateAction({register:true,login:false})}>
                      <div class="button-content">
                      <span data-group="HEADER" data-key="REGISTER">Register</span>
                      </div>
                    </button>
                    <div class="language-switcher svelte-1gt1ody" role="button" tabindex="0">
                      <button class="icon-container">
                          <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M17.2285 2.4873C17.309 2.62239 17.3753 2.75393 17.4278 2.87963C17.79 3.56976 17.9203 4.36806 17.7175 5.11515C17.5038 5.90195 16.9396 6.55229 16.0784 6.89352C15.6965 7.04481 15.5675 7.18995 15.5113 7.27487C15.4419 7.3796 15.402 7.51059 15.35 7.79639L15.3358 7.87595C15.2915 8.12849 15.2234 8.51653 15.0402 8.88618C14.815 9.3405 14.4463 9.7282 13.8725 10.0314C12.2984 10.863 10.1737 10.517 8.26524 8.5005C7.34172 7.52467 6.99603 7.24956 6.37624 7.18414C6.36467 7.18293 6.35312 7.18147 6.3416 7.17978C5.95439 7.12293 5.17404 7.17234 4.2954 7.59981C2.96147 9.56844 2.18164 11.9443 2.18164 14.5014C2.18164 21.2041 7.53502 26.6563 14.1993 26.8155C14.1135 26.752 14.0368 26.6923 13.9696 26.6377C13.2676 26.1117 12.8727 25.4552 12.8319 24.6955C12.7938 23.9869 13.0748 23.3339 13.3817 22.8063C13.8292 22.0368 13.965 21.7881 14.0354 21.5059C14.1101 21.2062 14.1163 20.8464 14.1163 19.8233C14.1163 19.2592 14.1987 18.6907 14.4512 18.1825C14.7138 17.654 15.1341 17.2451 15.7065 16.9805C16.7773 16.4857 18.3325 16.52 20.396 16.9327C20.633 16.9801 20.8822 16.9443 21.2103 16.8093C21.4829 16.6973 21.7433 16.5481 22.064 16.3643C22.1642 16.307 22.2702 16.2463 22.3842 16.1823C23.282 15.6785 24.5093 15.0795 26.078 15.6307C26.1156 15.6439 26.152 15.6597 26.1874 15.6779C26.3361 15.7547 26.5194 15.868 26.7245 16.0182C26.7857 15.521 26.8171 15.0147 26.8171 14.5014C26.8171 8.63585 22.718 3.72939 17.2285 2.4873Z" fill="#97A1C2" fill-opacity="0.4">
                          </path><path d="M14.4441 2.18457C15.3264 2.6862 15.7405 3.2833 15.8492 3.55983C15.8621 3.59262 15.877 3.62456 15.8938 3.65552C16.0984 4.03251 16.1325 4.39567 16.0593 4.66544C15.9923 4.9118 15.8207 5.14778 15.4457 5.29634C14.8192 5.54455 14.3726 5.88283 14.0787 6.32667C13.798 6.75069 13.7133 7.19382 13.6595 7.48892L13.6513 7.53381C13.5958 7.83893 13.5691 7.98541 13.5006 8.12367C13.4503 8.22527 13.3552 8.36173 13.07 8.5124C12.3532 8.8911 11.0418 8.93409 9.51399 7.31978C8.63135 6.38717 7.88991 5.62216 6.57404 5.47744C6.44537 5.45932 6.30417 5.44773 6.15234 5.44413C8.33375 3.43297 11.2456 2.19876 14.4441 2.18457Z" fill="#97A1C2"></path><path d="M26.3291 17.9447C25.9599 17.5738 25.6328 17.3385 25.4479 17.2328C24.6582 16.9778 24.0331 17.2285 23.2249 17.6819C23.1472 17.7256 23.0649 17.7728 22.9794 17.822C22.6421 18.0157 22.2507 18.2405 21.8638 18.3997C21.3488 18.6114 20.741 18.7552 20.0586 18.6188C18.0298 18.213 16.9593 18.2956 16.4271 18.5415C16.1981 18.6473 16.0727 18.7818 15.9901 18.9482C15.8973 19.1347 15.8347 19.4124 15.8347 19.8241V19.9389C15.835 20.8038 15.8352 21.3913 15.7029 21.9223C15.5664 22.4696 15.2952 22.9357 14.918 23.5838L14.8672 23.671C14.6205 24.0953 14.5366 24.3942 14.5479 24.604C14.5561 24.7567 14.6189 24.9806 15.0096 25.2702C15.0209 25.2785 15.0319 25.2871 15.0426 25.2959C15.4175 25.6031 16.2054 26.1274 17.1546 26.5329C21.5602 25.5649 25.0815 22.2387 26.3291 17.9447Z" fill="#97A1C2"></path></svg>
                      </button>
                    </div>
                  </div>
              </div>
            </div>
          </header>
        </main>
      </div>
       </div>
      <div style={{ position: "relative", height: 0 }}>
        <iframe
          src={url}
          title="Responsive Iframe"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100vh",
            border: "none"
          }}
        ></iframe>
      </div>
      {(show.login || show.register) && <AuthModal show={show} close={close} setUrl={setUrl} authenticateAction={authenticateAction}/>}  
    </div>
  )
}

export default MainPage